import { MainHeader } from "../../common/components/MainHeader";
import { Button, Grid } from "semantic-ui-react";
import React from "react";
import { useAsync } from "react-async";
import { AxiosEmployeeAPI } from "../Api";
import { PlaceholderHeader } from "../../common/components/PlaceholderHeader";
import { NavLink, useRouteMatch } from "react-router-dom";

export const EmployeeTitle = ({ employee_id, myPage }) => {
  const { data, isPending, error } = useAsync({
    promiseFn: AxiosEmployeeAPI.getById,
    watch: employee_id,
    employee_id: employee_id,
    expand: "name",
  });
  let { url } = useRouteMatch();

  if (isPending) return <PlaceholderHeader />;
  if (error) return <MainHeader title="(Funcionário desconhecido)" />;
  if (data)
    return (
      <>
        <MainHeader title={data.name} />
        <Grid>
          <Grid.Row columns={1}>
            <Grid.Column>
              <Button as={NavLink} to={`${url}/info`}>
                {myPage ? "Minhas informações" : "Informações gerais"}
              </Button>
              <Button as={NavLink} to={`${url}/time`}>
                Equipe
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
};
